export const OurTeam = [
    "In this modern development world, creating user-friendly and interactive interfaces has become very important for businesses to develop web and mobile applications. With so many technologies available such as Xamarin, Flutter, Ionic etc., the functionalities and features offered by React Native framework are highly unbeatable. It is a JavaScript framework composes rich mobile UI from Declarative components. In order to provide the best and custom React Native mobile applications, we have extended our development skills to the world's most booming technologies and ideas.",
    "It has rich UI Components. Some of the top companies Instagram, Netflix, Facebook and Walmart relies on React native. Applications developed with react-native are same speed like native application."
]
export const OtherMobileServices = [
    {ul: [
        {li: "Flutter development",
        path: "/services/flutter-development"},
        {li: "Ionic development",
        path: "/services/ionic-development"},
        {li: "PhoneGap development",
        path: "/services/phonegap-development"},
    ]}
]
export const WhyChooseUs = [
    "IStellar is one of the best react native companies for react native app development services, building native mobile apps using JavaScript and React. We develop native iOS and Android apps using the latest React Native JavaScript library. We have dedicated React Native developers and React Native UI designer who can develop react native apps and deliver a customized solution as per client's requirements at competitive price.",
    "From consulting to design, development, testing, launch, and maintenance we do it all. Our team of best React Native app developers is armed with the latest react native dev tools and technologies."
]
export const WeCanHelpYouWith = [
"Develop React Native mobile application with backend",
"To develop cross-platform mobile apps",
"Help with amazing front end for mobile in React Native UI",
"Rewrite existing app using React Native for iPhone and Android",
"Get MVP(Minimum Viable Product) live ASAP",
"Add feature to React Native mobile application",
"Make the app compliant to the regulations",
"Custom mobile application development"
]
export const reactNativePara = [
    "Start working with IStellar that can provide everything for your mobile apps."
]
export const reactNativeImg = [
    "reactNative"
]
export const rnDevImg = [
    "rnDevImg"
]
export const cardServices = [
    {
        id: 1,
        title: "React Native front-end development",
        content: "With our development team's years of expertise, we resolve challenges over front-end development while building engaging mobile apps."
    }, {
        id: 2,
        title: "Custom React Native development",
        content: "Hire our dedicated React Native developers to avail the best and custom React Native mobile apps that meet your business demands."
    }, {
        id: 3,
        title: "Interactive React Native UI development",
        content: "OWe offered the best React Native development services with awesome UIs to create featured mobile applications."
    }, {
        id: 4,
        title: "MVP (Minimum Viable Product)",
        content: "We build robust and secure mobile applications based on MVP using React Native and its features."
    }, {
        id: 5,
        title: "App specialization and design",
        content: "It doesn't matter what business you own, you can get the best solutions over app specialization and design."
    }, {
        id: 6,
        title: "API incorporation",
        content: "Our React Native developers are specialized in API integration with effective data flow and solution components."
    }, {
        id: 7,
        title: "Project consultation",
        content: "Our experts have strong knowledge in the field of React Native, you can contact and check with them for consultation for your project."
    }, {
        id: 8,
        title: "Innovative development approach",
        content: "Our team of developers deploys innovative development approach to build your React Native mobile apps that also prevent any sensitive data loss."
    }, {
        id: 9,
        title: "Maintenance and support",
        content: "Our development team provide complete maintenance and support to meet your expectations in terms of quality and services."
    }
]